import { useBreakoutRoomGql } from './breakoutRoom/breakoutRoomGql';
import {
  breakoutRoomSchema,
  typesEnum,
} from './breakoutRoom/breakoutRoomSchema';

export const breakoutRoomModel = {
  gql: useBreakoutRoomGql(),
  schema: breakoutRoomSchema,
  enums: {
    types: typesEnum,
  },
};
